import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
// import Timer from "../widget/timer";
import Footer from "../layout/footer";
import Left_Arrow from '../../image/header/left-arrow.png';
// import Down_Arrow from '../../image/header/down_arrow.png';
import './comp.css';
import { Link } from "react-router-dom";
import Sub2_Judge1 from '../../image/comp/sub2/IrJosephLO.jpg';
import Sub2_Judge2 from '../../image/comp/sub2/MrAlexHo.jpg';
import Sub2_Judge3 from '../../image/comp/sub2/IrAliceChow.jpg';
import Sub2_Judge4 from '../../image/comp/sub2/DrCrystalFok.jpg';
import Sub2_Judge5 from '../../image/comp/sub2/MrDanielCHEUNG.jpg';
import Sub2_Judge6 from '../../image/comp/sub2/MsGladysOon.jpg';
import Sub2_Judge7 from '../../image/comp/sub2/MrKingChan.jpg';
import Sub2_Judge8 from '../../image/comp/sub2/MrVincentChow.jpg';

class Comp extends Component {
    state = {
        isScrollToSubMenu: false,
        SubMenuHeight: 0,
        sub1: true,
        sub2: false,
        sub3: false,
        sub4: false,
        sub5: false,
        sub6: false,
        sub7: false,
        sub8: false,
        sub9: false,
    }
    clickScrollSub2(n) {
        let subX = document.getElementById("comp-sub-menu-gp-2");

        subX.scrollLeft += n; // Scroll n px
    }

    handleScroll = () => {
        let ScrollNow = window.scrollY;
        let topMenuHeight = 135;
        if (window.innerWidth <= 593) {
            topMenuHeight = window.innerWidth * 0.135;
        } else if (window.innerWidth <= 1100) {
            topMenuHeight = 80;
        }

        var subMenuTop = this.state.SubMenuHeight - topMenuHeight;
        if (ScrollNow >= subMenuTop) {
            setTimeout(() => {
                this.setState({ isScrollToSubMenu: true })
            }, 0);
        } else {
            setTimeout(() => {
                this.setState({ isScrollToSubMenu: false })
            }, 0);
        }
    }
    updateSubMenuHeight = () => {
        const SubMenuHeight = document.getElementById("comp-sub-menu-2").offsetTop;
        setTimeout(() => {
            this.setState({ SubMenuHeight: SubMenuHeight });
        }, 0);
    }
    updateSub = (n) => {
        this.goToSub();

        switch (n) {
            case 1:
                setTimeout(() => {
                    this.setState({ sub1: true, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 2:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: true, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 3:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: true, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 4:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: true, sub5: false, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;

            case 5:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: true, sub6: false, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 6:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: true, sub7: false, sub8: false, sub9: false, });
                }, 0);
                break;
            case 7:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: true, sub8: false, sub9: false, });
                }, 0);
                break;
            case 8:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: true, sub9: false, });
                }, 0);
                break;
            case 9:
                setTimeout(() => {
                    this.setState({ sub1: false, sub2: false, sub3: false, sub4: false, sub5: false, sub6: false, sub7: false, sub8: false, sub9: true, });
                }, 0);
                break;
            default:
                break;
        }
    }
    checkSub = (n) => {
        switch (n) {
            case "Background":
                this.updateSub(1);
                break;
            case "Description":
                this.updateSub(2);
                break;
            case "Evaluation":
                this.updateSub(3);
                break;
            case "Prizes":
                this.updateSub(4);
                break;
            case "Timeline":
                this.updateSub(5);
                break;
            case "Acknowledgements":
                this.updateSub(6);
                break;
            case "Data":
                this.updateSub(7);
                break;
            case "Rules":
                this.updateSub(8);
                break;
            case "Results":
                this.updateSub(9);
                break;
            default:
                break;

        }
    }
    goToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "initial"
        });
    }
    goToSub() {
        let subHeight = document.getElementById("comp-sub").offsetTop;
        let topMenuHeight = 135;
        let subMenuHeight = 74;

        if (window.innerWidth <= 593) {
            topMenuHeight = window.innerWidth * 0.135;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 480) {
            topMenuHeight = 80;
            subMenuHeight = window.innerWidth * 0.11068;
        } else if (window.innerWidth <= 930) {
            topMenuHeight = 80;
        }


        window.scrollTo({
            top: subHeight - topMenuHeight - subMenuHeight,
            left: 0,
        });
    }
    componentDidMount() {
        this.updateSubMenuHeight();
        window.addEventListener('scroll', this.handleScroll);

        var sub = window.location.hash;
        sub = sub.slice(1);
        this.checkSub(sub);
    };
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        var sub = window.location.hash;
        sub = sub.slice(1);

        this.checkSub(sub);
    }
    render() {
        const { t } = this.props;
        const { isScrollToSubMenu, sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9 } = this.state;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('comp-meta-title')}</title>
                    <meta name="title" content={t('comp-meta-title')} />
                    <meta name="description" content={t('comp-meta-description')} />
                    <meta name="keywords" content={t('comp-meta-keywords')} />
                </MetaTags>
                <div className="div-comp">
                    <div className="comp-intro">
                        <div className="container-fluid d-flex justify-content-center div-comp-intro">
                            <div>
                                <div className="comp-intro-headline-1 text-center">{t('comp-intro-headline-1-1')}<br className="d-md-none" />{t('comp-intro-headline-1-2')}</div>
                                <div className="comp-intro-headline-2 text-center my-2">{t('comp-intro-headline-2')}</div>
                                <div className="comp-intro-headline-3 text-center mt-3"><span>{t('comp-intro-headline-3')}</span><br className={t('TC_SC_none d-md-none')} /><strong className="comp-intro-headline-4">{t('comp-intro-headline-4')}</strong><span>{t('comp-intro-headline-5')}</span></div>

                                <div className="d-flex justify-content-center text-center mt-3">
                                    <div className="col-12 col-md-10 px-3"><span className={t('TXT_bold')}>{t('comp-intro-text-1')}</span></div>
                                </div>
                                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center align-items-md-stretch my-5">
                                    <Link className="card comp-card-1 p-1 my-4 m-sm-4 m-md-2 h-max no_border" aria-current="page" to={match + "/competition/"} onClick={() => this.updateSub(1)}>
                                        <div className="comp-card-item-1 text-center d-flex justify-content-center align-items-center px-4 w-100"><div><div className="comp-card-text-1">{t('Build Your')}</div><div className="comp-card-text-2">{t('AI Model')}</div></div></div>
                                        <div className="card-body sub-theme-1-bar text-center p-1">
                                            <p className="card-text"><strong>{t('sub-theme-1-bar-text')}</strong></p>
                                        </div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text text-center"><strong>{t('sub-theme-1-text')}</strong></p>
                                        </div>
                                    </Link>
                                    <Link className="card comp-card-2 p-1 my-4 m-sm-4 m-md-2 h-max no_border" aria-current="page" to={match + "/competition2/"} onClick={() => this.updateSub(1)}>
                                        <div className="comp-card-item-2 text-center d-flex justify-content-center align-items-center px-4 w-100"><div><div className="comp-card-text-1">{t('Pitch Your')}</div><div className="comp-card-text-3">{t('Innovative Proposal')}</div></div></div>
                                        <div className="card-body sub-theme-2-bar text-center p-1">
                                            <p className="card-text"><strong>{t('sub-theme-2-bar-text')}</strong></p>
                                        </div>
                                        <div className="card-body d-flex align-items-center">
                                            <p className="card-text text-center"><strong>{t('sub-theme-2-text')}</strong></p>
                                        </div>
                                    </Link>
                                </div>
                                <div className="d-flex justify-content-center text-center comp-intro-text my-4">
                                    <div className="col-12 col-md-10 px-3"><strong>{t('comp-intro-text-2')}</strong></div>
                                </div>
                                {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border d-flex justify-content-center"><button className="btn btn-highlight01 w-100 py-1"><strong>{t('Join the Competition')}</strong></button></a> */}
                                {/* <div className="d-flex justify-content-center my-4">
                                    <Timer date="5/23/2025 23:59 GMT+8" type="comp" />
                                </div> */}
                                <div className={t('d-flex justify-content-center div-comp-intro-btn')}>
                                    {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_conf_comp btn_JnComp TXT_medium">{t('APPLY NOW')}</button></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-start div-comp-intro-banner">
                            <div className="comp-intro-banner"></div>
                        </div>
                    </div>
                    <div id="comp-sub-menu-2" className={isScrollToSubMenu ? "fixed comp-sub-menu-2" : "comp-sub-menu-2"}>
                        <div className="d-flex d-sm-block justify-content-center">
                            <div className="d-none d-sm-flex justify-content-center">
                                <div className="comp-sub-menu-item comp-sub-menu-item-1 text-center px-4 mt-2" onClick={() => this.updateSub(1)}>
                                    <strong>{t('comp-sub-menu-item-1')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-2 text-center px-4 mt-2" onClick={() => this.updateSub(2)}>
                                    <strong>{t('comp-sub-menu-item-2')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-3 text-center px-4 mt-2" onClick={() => this.updateSub(3)}>
                                    <strong>{t('comp-sub-menu-item-3')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-4 text-center px-4 mt-2" onClick={() => this.updateSub(4)}>
                                    <strong>{t('comp-sub-menu-item-4')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-9 text-center px-4 mt-2" onClick={() => this.updateSub(9)}>
                                    <strong>{t('comp-sub-menu-item-9')}</strong>
                                </div>
                                <div className="comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-5 text-center px-4 mt-2" onClick={() => this.updateSub(5)}>
                                    <strong>{t('comp-sub-menu-item-5')}</strong>
                                </div>
                            </div>
                            <div className="d-none d-sm-flex justify-content-center">
                                <div className="comp-sub-menu-item comp-sub-menu-item-6 text-center px-4 my-1" onClick={() => this.updateSub(6)}>
                                    <strong>{t('comp-sub-menu-item-6')}</strong>
                                </div>
                                {/* <div className="comp-sub-menu-item comp-sub-menu-item-7 text-center px-4 my-1" onClick={() => this.updateSub(7)}>
                                    <strong>{t('comp-sub-menu-item-7')}</strong>
                                </div> */}
                                <div className="comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-8 text-center px-4 my-1" onClick={() => this.updateSub(8)}>
                                    <strong>{t('comp-sub-menu-item-8')}</strong>
                                </div>
                                {/* <div className="d-flex justify-content-center align-items-end div-btn_comp-sub-menu">
                                    <a href="https://globalaichallenge.com/static/media/BAICE 2025 Application Form.docx" target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-xl btn-highlight01 w-100">{t('download-form-long')}</button></a>
                                </div> */}
                            </div>
                            <div className="d-flex d-sm-none justify-content-center">
                                <div className="left-arrow-2 p-2 d-flex justify-content-center" onClick={() => this.clickScrollSub2(-150)}><img src={Left_Arrow} className="mx-auto d-block" alt=""></img></div>
                                <div id="comp-sub-menu-gp-2" className="comp-sub-menu-gp-2 d-flex mt-2">
                                    {/* <div className="d-flex justify-content-center div-btn_comp-sub-menu-2">
                                        <a href="https://globalaichallenge.com/static/media/BAICE 2025 Application Form.docx" target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn btn-xl btn-highlight01 w-100 text-nowrap">{t('download-form')}</button></a>
                                    </div> */}
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-1 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(1)}>
                                        <span>{t('comp-sub-menu-item-1')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-2 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(2)}>
                                        <span>{t('comp-sub-menu-item-2')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-3 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(3)}>
                                        <span>{t('comp-sub-menu-item-3')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-4 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(4)}>
                                        <span>{t('comp-sub-menu-item-4')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-9 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(9)}>
                                        <span>{t('comp-sub-menu-item-9')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-5 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(5)}>
                                        <span>{t('comp-sub-menu-item-5')}</span>
                                    </div>
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-6 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(6)}>
                                        <span>{t('comp-sub-menu-item-6')}</span>
                                    </div>
                                    {/* <div className={t('comp-sub-menu-item comp-sub-menu-item-7 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(7)}>
                                        <span>{t('comp-sub-menu-item-7')}</span>
                                    </div> */}
                                    <div className={t('comp-sub-menu-item comp-sub-menu-item-end comp-sub-menu-item-8 text-center text-nowrap TXT_bold')} onClick={() => this.updateSub(8)}>
                                        <span>{t('comp-sub-menu-item-8')}</span>
                                    </div>
                                </div>
                                <div className="right-arrow-2 p-2 d-flex justify-content-center" onClick={() => this.clickScrollSub2(150)}><img src={Left_Arrow} className="mx-auto d-block" alt=""></img></div>
                            </div>
                        </div>
                    </div>
                    <div id="comp-sub" className="d-flex justify-content-center comp-sub">
                        <div className={sub1 ? "d-block col-12" : "d-none"}>
                            <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-1-headline')}</div>
                                    <div className="comp-sub-description">
                                        <p>{t('comp2-sub-1-text-1')}</p>
                                        <p>{t('comp2-sub-1-text-2')}</p>
                                        <p>{t('comp2-sub-1-text-3')}</p>
                                        <p>{t('comp2-sub-1-text-4')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub2 ? "d-block col-12" : "d-none"}>
                            <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-2-headline')}</div>
                                    <div className="comp-sub-description">
                                        <p>{t('comp2-sub-2-text-1')}</p>
                                        <ol>
                                            <li><strong>{t('comp2-sub-2-text-2')}</strong><br />{t('comp2-sub-2-text-3')}</li>
                                            <li><strong>{t('comp2-sub-2-text-4')}</strong><br />{t('comp2-sub-2-text-5')}</li>
                                            <li><strong>{t('comp2-sub-2-text-6')}</strong><br />{t('comp2-sub-2-text-7')}</li>
                                            <li><strong>{t('comp2-sub-2-text-8')}</strong><br />{t('comp2-sub-2-text-9')}</li>
                                            <li><strong>{t('comp2-sub-2-text-10')}</strong><br />{t('comp2-sub-2-text-11')}</li>
                                            <li><strong>{t('comp2-sub-2-text-12')}</strong><br />{t('comp2-sub-2-text-13')}</li>
                                        </ol>
                                        <p>{t('comp2-sub-2-text-14')}</p>
                                        <p>{t('comp2-sub-2-text-15')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub3 ? "d-block col-12" : "d-none"}>
                            <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-3-headline')}</div>
                                    <div className="comp-sub-description">
                                        <p>{t('comp2-sub-3-text-1')}</p>
                                        <p>{t('comp2-sub-3-text-2')}</p>
                                        {t('comp2-sub-3-text-3')}<br />{t('comp2-sub-3-text-4')}<br />
                                        <ul>
                                            <li>{t('comp2-sub-3-text-5')}</li>
                                            <li>{t('comp2-sub-3-text-6')}</li>
                                            <li>{t('comp2-sub-3-text-7')}</li>
                                        </ul>
                                        {t('comp2-sub-3-text-8')}
                                        <ul>
                                            <li>{t('comp2-sub-3-text-9')}</li>
                                            <li>{t('comp2-sub-3-text-10')}</li>
                                            <li>{t('comp2-sub-3-text-11')}</li>
                                        </ul>
                                        {t('comp2-sub-3-text-12')}
                                        <ul>
                                            <li>{t('comp2-sub-3-text-13')}</li>
                                            <li>{t('comp2-sub-3-text-14')}</li>
                                            <li>{t('comp2-sub-3-text-15')}</li>
                                        </ul>
                                        {t('comp2-sub-3-text-16')}
                                        <ul>
                                            <li>{t('comp2-sub-3-text-17')}</li>
                                            <li>{t('comp2-sub-3-text-18')}</li>
                                            <li>{t('comp2-sub-3-text-19')}</li>
                                        </ul>
                                        {t('comp2-sub-3-text-20')}
                                        <ul>
                                            <li>{t('comp2-sub-3-text-21')}</li>
                                            <li>{t('comp2-sub-3-text-22')}</li>
                                            <li>{t('comp2-sub-3-text-23')}</li>
                                        </ul>
                                        {t('comp2-sub-3-text-24')}
                                        <ul>
                                            <li>{t('comp2-sub-3-text-25')}</li>
                                            <li>{t('comp2-sub-3-text-26')}</li>
                                            <li>{t('comp2-sub-3-text-27')}</li>
                                        </ul>
                                        <p>{t('comp2-sub-3-text-28')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub4 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-4-headline')}</div>
                            <div className="comp2-sub-4-img-1"></div>

                            {/* <div className="container-fluid col-12 col-md-10 d-flex justify-content-center">
                                <div className="col-12">
                                    <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-4-headline')}</div>
                                    <div className="comp-sub-description">
                                        <ul>
                                            <li className="comp-sub-3-part-list-2-inner"><span>{t('comp2-sub-4-text-1')}</span></li>
                                            <li className="comp-sub-3-part-list-2-inner"><span>{t('comp2-sub-4-text-2')}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className={sub9 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-9-headline')}</div>
                            <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-10 d-flex">
                                    <p>{t('comp2-sub-9-text-1')}</p>
                                </div>
                            </div>
                            {/* <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-10 d-flex">
                                    <p>{t('comp-sub-9-text-2')}<a href={t('sub-9-link')} target="_blank" rel="noopener noreferrer">{t('comp-sub-9-text-3')}</a>{t('comp-sub-9-text-4')}</p>
                                </div>
                            </div> */}
                            <div className="comp-sub-9-temp d-flex justify-content-center">
                                <div className="comp2-sub-9-temp-1"></div>
                            </div>
                        </div>
                        <div className={sub5 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-5-headline')}</div>
                            <div className="comp2-timeline-content col-12">
                                <div className="comp2-timeline-content-btn"><a href="mailto:aichallenge@emsd.gov.hk" target="_blank" rel="noopener noreferrer" className="no_border d-block w-100 h-100">&nbsp;</a></div>
                            </div>
                            {/* <div className="text-center">
                                <h3 className="comp-sub-menu-2-text pt-5">{t('comp2-sub-5-text-1')}</h3>
                                <h5>{t('comp2-sub-5-text-2')}</h5>
                                <h3 className="comp-sub-menu-2-text pt-5">{t('comp2-sub-5-text-3')}</h3>
                                <h5>{t('comp2-sub-5-text-4')}</h5>
                                <h3 className="comp-sub-menu-2-text pt-5">{t('comp2-sub-5-text-5')}</h3>
                                <h5>{t('comp2-sub-5-text-6')}</h5>
                                <h3 className="comp-sub-menu-2-text pt-5">{t('comp2-sub-5-text-7')}</h3>
                                <h5>{t('comp2-sub-5-text-8')}</h5>
                                <p className="p-5 m-5"></p>
                            </div> */}
                        </div>
                        <div className={sub6 ? "d-block col-12" : "d-none"}>
                            <h2 className="text-center my-4">{t('comp-sub-6-headline')}</h2>
                            <div className="container-fluid col-12 col-lg-10 d-flex flex-column">
                                <div className="comp-sub-6-section">
                                    {/* <div className="comp-sub-part-md comp-sub-6-part-1 d-flex justify-content-center col-12">
                                        <div className={t('comp-sub-part-headline-md d-flex align-items-center TXT_medium')}>{t('comp2-sub-6-part-headline-1')}</div>
                                    </div> */}

                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge1} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-1')}</h4>
                                                <p className="">{t('comp2-sub-6-text-2')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge2} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-3')}</h4>
                                                <p className="">{t('comp2-sub-6-text-4')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge3} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-5')}</h4>
                                                <p className="">{t('comp2-sub-6-text-6')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge4} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-7')}</h4>
                                                <p className="">{t('comp2-sub-6-text-8')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge5} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-9')}</h4>
                                                <p className="">{t('comp2-sub-6-text-10')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge6} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-11')}</h4>
                                                <p className="">{t('comp2-sub-6-text-12')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge7} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-13')}</h4>
                                                <p className="">{t('comp2-sub-6-text-14')}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="comp-sub-part-md-item-1 d-sm-flex">
                                        <div className="col-12 col-sm-3 d-flex align-items-center justify-content-center justify-content-sm-end"><div className="comp-sub-6-img"><img src={Sub2_Judge8} className='img-fluid' alt=''></img></div></div>
                                        <div className="col-12 col-sm-9 d-flex align-items-center justify-content-center text-center text-sm-start">
                                            <div className="col-12 col-sm-10 mt-4 mt-sm-0">
                                                <h4>{t('comp2-sub-6-text-15')}</h4>
                                                <p className="">{t('comp2-sub-6-text-16')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={sub7 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-7-headline')}</div>
                            <div className="comp-sub-description">
                                <div className="container-fluid col-12 col-md-10">
                                    <p>{t('comp2-sub-7-text-1')}</p>
                                    <p>{t('comp2-sub-7-text-2')}</p>
                                </div>
                            </div>
                        </div>
                        <div className={sub8 ? "d-block col-12" : "d-none"}>
                            <div className={t('comp-sub-headline text-center TXT_medium')}>{t('comp-sub-8-headline')}</div>
                            <div className="container-fluid d-flex justify-content-center col-12">
                                <div className="comp-sub-part-detail col-12 col-md-10">
                                    <div className="comp-sub-description">
                                        <p>
                                            <div className="comp-sub-8-list">
                                                <ul>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp2-sub-8-text-1')}</span><br />
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp2-sub-8-text-2')}</span><br />
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp2-sub-8-text-3')}</span><br />
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp2-sub-8-text-4')}</span><br />
                                                    </li>
                                                    <li className="comp-sub-8-list-inner">
                                                        <span className={t('TXT_bold')}>{t('comp2-sub-8-text-5')}</span><br />
                                                    </li>
                                                </ul>
                                                <p className="pt-3"><strong>{t('comp2-sub-8-text-6')}</strong></p>
                                                <p>{t('comp2-sub-8-text-7')}<a href="mailto:aichallenge@emsd.gov.hk" target="_blank" rel="noopener noreferrer">{t('comp2-sub-8-text-8')}</a>{t('comp2-sub-8-text-9')}</p>
                                                <p><strong>{t('comp2-sub-8-text-10')}</strong></p>
                                                <ol className="comp-sub-8-list-ol">
                                                    <li><span>{t('comp2-sub-8-text-11')}</span></li>
                                                    <li><span>{t('comp2-sub-8-text-12')}</span></li>
                                                    <li><span>{t('comp2-sub-8-text-13')}</span></li>
                                                    <li><span>{t('comp2-sub-8-text-14')}</span></li>
                                                    <li><span>{t('comp2-sub-8-text-15')}</span></li>
                                                    <li><span>{t('comp2-sub-8-text-16')}</span></li>
                                                </ol>
                                                <p>{t('comp2-sub-8-text-17')}<br />{t('comp2-sub-8-text-18')}</p>

                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <Footer />
                    {/*  Modal */}
                    <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content bg-black">
                                <div className="modal-body">
                                    <div className="d-flex justify-content-end">
                                        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>


                                    <p>{t('alert-msg-1')}</p>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Comp);



// WEBPACK FOOTER //
// ./src/components/pages/comp2.js